(() => {
  const btn = document.getElementById('toTop');
  if (!btn) return;

  // Locate header (common Shopify selectors)
  const header = document.querySelector('header, .shopify-section-header, #shopify-section-header, .site-header, .Header, .header');

  // Sentinel just after header = show as soon as header is out of view
  let trigger = document.getElementById('toTopTrigger');
  if (!trigger) {
    trigger = document.createElement('div');
    trigger.id = 'toTopTrigger';
    trigger.style.cssText = 'position:absolute;width:1px;height:1px;';
    (header && header.parentNode ? header : document.body).insertAdjacentElement('afterend', trigger);
  }

  const show = () => { btn.classList.add('show'); btn.removeAttribute('hidden'); };
  const hide = () => { btn.classList.remove('show'); btn.setAttribute('hidden',''); };

  // IntersectionObserver to toggle visibility past header
  if ('IntersectionObserver' in window){
    const io = new IntersectionObserver(([entry]) => entry.isIntersecting ? hide() : show(), {
      root:null, rootMargin:'0px 0px -1px 0px', threshold:0
    });
    io.observe(trigger);
  } else {
    const lim = (header ? header.offsetHeight : 80);
    const onScroll = () => (window.scrollY > lim ? show() : hide());
    document.addEventListener('scroll', onScroll, { passive:true }); onScroll();
  }

  // Scroll progress ring (sets --p from 0..100)
  const setProgress = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const docH = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.documentElement.clientHeight
    );
    const winH = window.innerHeight || document.documentElement.clientHeight;
    const max = Math.max(docH - winH, 1);
    const pct = Math.min(Math.max((scrollTop / max) * 100, 0), 100);
    btn.style.setProperty('--p', pct.toFixed(2) + '%');
  };
  setProgress();
  document.addEventListener('scroll', setProgress, { passive:true });
  window.addEventListener('resize', setProgress);

  // Click → scroll to top (respect reduced motion) + subtle pulse
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, left: 0, behavior: prefersReduced ? 'auto' : 'smooth' });

    // Tiny pulse feedback
    btn.animate(
      [{ transform:'translateY(-3px) scale(1.02)' }, { transform:'translateY(-1px) scale(.98)' }, { transform:'translateY(-3px) scale(1.02)'}],
      { duration:220, easing:'ease-out' }
    );
  }, { passive:true });
})();
